import React, { useState } from 'react';
import CustomSlider from '../../../../../Components/Organisms/CustomSlider';
import { coins } from './svg';
import { toIndianRs, toNumberFormat } from '../../../../../helpers';
import { useDispatch } from 'react-redux';
import store from '../../../../../store';
import { dealAction } from '../../../../../store/deal-slice';

function Bag({ cartValue }) {
    const dispatch = useDispatch();
    const [deleteIndex, setDeleteIndex] = useState(-2);
    const onClickHandleDeleteCart = (index) => {
        setDeleteIndex(index);
    };
    const onDeleteCart = (item, itemId) => {
        window?.webengage?.track('RemoveFromCartClicked', {
            ProductName: `${item?.title}`,
            Price: `${item?.productMrp}`,
            PointsRequired: `${item?.points}`
        });
        const oldCartData = localStorage.getItem('cartData');

        if (!oldCartData) return;

        let cartData = JSON.parse(oldCartData);

        // Find the item to remove based on `itemId`
        const itemIndex = cartData.cartValues.findIndex(
            (item) => item.id === itemId
        );

        if (itemIndex === -1) return; // Item not found, do nothing

        // Get the item to remove for updating totalMrp
        const itemToRemove = cartData.cartValues[itemIndex];

        // Remove the item from cartValues
        cartData.cartValues.splice(itemIndex, 1);

        // Update totalMrp and totalProduct
        cartData.totalMrp -= itemToRemove.productMrp;
        cartData.totalPoints -= itemToRemove.points;
        cartData.totalShippingFee -= itemToRemove.productShippingFee;
        cartData.totalConvenienceFee -= itemToRemove.productConvenienceFee;
        cartData.totalProduct -= 1;

        setDeleteIndex(-2);

        // Save updated cart data to localStorage
        localStorage.setItem('cartData', JSON.stringify(cartData));
        // Dispatch a custom event to notify other components
        window.dispatchEvent(new Event('cartUpdated'));
        const state = store.getState(); // Access the current store state
        const isRefresh = !state.deals.isRefreshRewards;
        dispatch(dealAction.setIsRewardRefreshing(isRefresh));
    };
    return (
        <>
            <div className=" flex flex-col  lg:px-0 lg:justify-center pb-2">
                <h1 className="font-bold text-base">Product Details</h1>
                <div className="max-h-[57vh] md:max-h-[60vh] 2xl:max-h-[70vh] overflow-y-scroll scrollbar-thin  lg:scrollbar-hide">
                    <div className="flex-grow p-2 space-y-4">
                        {cartValue.map((cart, index) => (
                            <div className="relative items-start pb-2    border-b border-gray-200">
                                <div
                                    key={index}
                                    className="flex flex-row gap-3 "
                                >
                                    {/* Product Image */}
                                    <div className="flex flex-col   min-w-max items-start">
                                        <img
                                            src={
                                                cart?.thumbnailImageUrl
                                                    ? cart?.thumbnailImageUrl
                                                    : cart?.displayImageUrl
                                            }
                                            alt="Product Image"
                                            className="w-24 h-24 lg:w-20 lg:h-20 object-cover cursor-pointer"
                                        />
                                    </div>
                                    <div className="flex flex-col  gap-1   justify-center flex-grow ">
                                        <p className="font-semibold text-sm text-black">
                                            {cart?.title}
                                        </p>
                                        <p className="text-primary text-base font-bold">
                                            {toIndianRs(cart?.productMrp)}
                                        </p>
                                    </div>
                                    <div className="sm:w-[10%] flex justify-center mr-1.5">
                                        <button
                                            onClick={() =>
                                                onClickHandleDeleteCart(index)
                                            }
                                            className="text-red-500  p-1 rounded-full transition"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="32"
                                                height="32"
                                                viewBox="0 0 26 26"
                                            >
                                                <g
                                                    id="Group_12543"
                                                    data-name="Group 12543"
                                                    transform="translate(-1310 -69)"
                                                >
                                                    <rect
                                                        id="Rectangle_17370"
                                                        data-name="Rectangle 17370"
                                                        width="26"
                                                        height="26"
                                                        rx="5"
                                                        transform="translate(1310 69)"
                                                        fill="#ecedf6"
                                                    />
                                                    <g
                                                        id="delete-93"
                                                        transform="translate(1315.333 76)"
                                                    >
                                                        <path
                                                            id="Path_6546"
                                                            data-name="Path 6546"
                                                            d="M146.465,149.1H141.6a1.893,1.893,0,0,1-1.89-1.892v-7.564h8.643v7.564A1.894,1.894,0,0,1,146.465,149.1Zm-6.213-8.914v7.022a1.352,1.352,0,0,0,1.35,1.351h4.863a1.351,1.351,0,0,0,1.35-1.351V140.19Z"
                                                            transform="translate(-136.443 -138.027)"
                                                            fill="red"
                                                            stroke="red"
                                                            stroke-width="0.5"
                                                        />
                                                        <path
                                                            id="Path_6547"
                                                            data-name="Path 6547"
                                                            d="M352.964,2.163h-3.78V1.082A1.082,1.082,0,0,1,350.263,0h1.621a1.081,1.081,0,0,1,1.079,1.082Zm-3.24-.542h2.7V1.082a.54.54,0,0,0-.54-.54h-1.62a.541.541,0,0,0-.54.54Z"
                                                            transform="translate(-343.484)"
                                                            fill="red"
                                                            stroke="red"
                                                            stroke-width="0.5"
                                                        />
                                                        <path
                                                            id="Path_6548"
                                                            data-name="Path 6548"
                                                            d="M13.262,140.19H1.918a.272.272,0,0,1,0-.542H13.262a.271.271,0,0,1,0,.542ZM7.59,146.672a.272.272,0,0,1-.271-.27v-4.593a.271.271,0,0,1,.542,0V146.4A.272.272,0,0,1,7.59,146.672Zm-2.161-.54a.272.272,0,0,1-.271-.27V142.35a.271.271,0,0,1,.542,0v3.511a.27.27,0,0,1-.27.27Zm4.051,0a.27.27,0,0,1-.268-.27V142.35a.27.27,0,0,1,.539,0v3.511a.271.271,0,0,1-.271.27Z"
                                                            transform="translate(0 -138.027)"
                                                            fill="red"
                                                            stroke="red"
                                                            stroke-width="0.5"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                {index === deleteIndex && (
                                    <div className="flex flex-col justify-center absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
                                        <div className="flex justify-center items-center mb-4"></div>

                                        <p className="text-center text-sm font-semibold text-black-600 mb-4">
                                            Remove item from Gift Basket?
                                        </p>

                                        <div className="flex items-center justify-center gap-6 mb-4">
                                            <button
                                                className="bg-white border border-primary text-sm text-primary px-4 py-2 rounded-lg"
                                                onClick={() =>
                                                    setDeleteIndex(-2)
                                                }
                                            >
                                                No
                                            </button>
                                            <button
                                                className="bg-primary text-white text-sm px-4 py-2 rounded-lg "
                                                onClick={() =>
                                                    onDeleteCart(cart, cart?.id)
                                                }
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                {/* <div className="flex-grow p-4 space-y-4">
                    {cartValue.map((deal, index) => (
                        <div className="flex flex-col lg:flex-row gap-6 lg:items-center py-4">
                            <img
                                className="h-20 w-28 rounded-md"
                                src={deal?.displayImageUrl}
                            />

                            <div className="flex flex-col gap-2">
                                <div className="flex items-center">
                                    <div>
                                        <h4 className="text-base font-bold">
                                            {deal?.title}
                                        </h4>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3">
                                    <p className="text-primary font-bold">
                                        {toIndianRs(deal?.productMrp)}
                                    </p>
                                </div>
                            </div>
                            <hr className="mx-4 my-4 border-b-[2px] border-gray-100" />
                        </div>
                    ))}
                </div> */}
            </div>
        </>
    );
}

export default Bag;
